<template>
	<div>
		<HotelDatePicker
  :allowedRanges="[7,10,14]"
></HotelDatePicker>
		<hr>
		<Loading v-if="!settings && disabled_dates.length == 0"></Loading>
		<VueHotelDatepicker v-else :maxDate="settings.find(s => s.label == 'booking_open_until').value" :disabledDates="disabled_dates" format="YYYY-MM-DD" 
			placeholder="Válasszon dátumot" 
			separator="-" 
			:weekList="['Vas','Hé','Ke','Sze','Csü','Pé','Szo']" 
			:monthList="['Január','Február','Március','Április','Május','Június','Július','Augusztus','Szeptember','Október','November','December']" 
			fromText="Érkezés" 
			toText="Távozás" 
			resetText="visszaállít" 
			confirmText="Jóváhagy" 
		/>
		<VueHotelDatepicker :maxDate="settings.find(s => s.label == 'booking_open_until').value" :minNight="3" format="YYYY-MM-DD" 
			placeholder="Válasszon dátumot" 
			separator="-" 
			:weekList="['Vas','Hé','Ke','Sze','Csü','Pé','Szo']" 
			:monthList="['Január','Február','Március','Április','Május','Június','Július','Augusztus','Szeptember','Október','November','December']" 
			fromText="Érkezés" 
			toText="Távozás" 
			resetText="visszaállít" 
			confirmText="Jóváhagy" 
		/>
	</div>
</template>

<script>
import HotelDatePicker from 'vue-hotel-datepicker'
import 'vue-hotel-datepicker/dist/vueHotelDatepicker.css';

import VueHotelDatepicker from '@northwalker/vue-hotel-datepicker'
import Setting from "../apis/Setting";
import moment from 'moment';
export default {
  components: {
    HotelDatePicker,VueHotelDatepicker
  },
	data(){
		return {
			settings:null,
			disabled_dates:[]
		}
	},
	created(){
		Setting.index()
		.then(response => {
			this.settings = response.data;
			let start = moment();
			let end = moment(this.settings.find(s => s.label == 'booking_open_until').value);

			let tmp = start.clone().subtract(1,'days');
			if( tmp.isAfter(start, 'd') && tmp.weekday() == 5){
				console.log(tmp,tmp.weekday())
				this.disabled_dates.push(tmp.format('YYYY-MM-DD'));
			}
			while( tmp.isBefore(end)){
				tmp.add(1, 'days');
				if(tmp.weekday() != 5){
					this.disabled_dates.push(tmp.format('YYYY-MM-DD'));
				}
			}
		}).catch(() => {
			this.settings = []
		});
	},
	/*computed:{
		disabled_dates(){
			if(!this.settings){
				return [];
			}else{
				let start = moment();
				let end = moment(this.settings.find(s => s.label == 'booking_open_until').value);
					
				var arr = [];
				
				let tmp = start.clone();
				if( tmp.isAfter(start, 'd') && tmp.weekday() == 5){
					arr.push(tmp.format('YYYY-MM-DD'));
				}
				while( tmp.isBefore(end) && tmp.weekday() == 5){
					tmp.add(1, 'days');
					arr.push(tmp.format('YYYY-MM-DD'));
				}
				return arr;
			}
		}
	}*/
}
</script>